import { ReactNode, createContext } from "react";
import { maxLarge, maxMedium, maxSmall } from "../../styles/tokens";

// TEXT

// STYLES

// DATA

// TYPES
export type WindowDimensionsProviderProps = {
  children?: ReactNode | undefined;
};

export type WindowDimensions = {
  size: WindowSize;

  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;

  width: number;
  height: number;
};

export type WindowSize = (typeof WINDOW_SIZES)[number];

// CONSTANTS
export const WINDOW_SIZES = ["small", "medium", "large", "xlarge"] as const;

export const WindowDimensionsContext = createContext<WindowDimensions | null>(
  null,
);

// FUNCTIONS
const getSize = (): WindowSize => {
  // ORDER IS IMPORTANT!!
  if (window.matchMedia(maxSmall).matches) {
    return "small";
  }

  if (window.matchMedia(maxMedium).matches) {
    return "medium";
  }

  if (window.matchMedia(maxLarge).matches) {
    return "large";
  }

  return "xlarge";
};

export const getWindowDimensions = (): WindowDimensions => {
  const size = getSize();

  return {
    size,

    isMobile: size === "small",
    isTablet: size === "small" || size === "medium",
    isDesktop: size === "large" || size === "xlarge",

    width: window.innerWidth,
    height: window.innerHeight,
  };
};

export const isServer = () => typeof document === "undefined";

// ASSETS
